function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { getResponsiveProps, sanitizeCustomProperties } from '../../utilities/css.js';
import styles from './Bleed.scss.js';
var Bleed = function Bleed(_ref) {
  var marginInline = _ref.marginInline,
    marginBlock = _ref.marginBlock,
    marginBlockStart = _ref.marginBlockStart,
    marginBlockEnd = _ref.marginBlockEnd,
    marginInlineStart = _ref.marginInlineStart,
    marginInlineEnd = _ref.marginInlineEnd,
    children = _ref.children;
  var getNegativeMargins = function getNegativeMargins(direction) {
    var xAxis = ['marginInlineStart', 'marginInlineEnd'];
    var yAxis = ['marginBlockStart', 'marginBlockEnd'];
    var directionValues = {
      marginBlockStart: marginBlockStart,
      marginBlockEnd: marginBlockEnd,
      marginInlineStart: marginInlineStart,
      marginInlineEnd: marginInlineEnd,
      marginInline: marginInline,
      marginBlock: marginBlock
    };
    if (directionValues[direction]) {
      return directionValues[direction];
    } else if (xAxis.includes(direction) && marginInline) {
      return directionValues.marginInline;
    } else if (yAxis.includes(direction) && marginBlock) {
      return directionValues.marginBlock;
    }
  };
  var negativeMarginBlockStart = getNegativeMargins('marginBlockStart');
  var negativeMarginBlockEnd = getNegativeMargins('marginBlockEnd');
  var negativeMarginInlineStart = getNegativeMargins('marginInlineStart');
  var negativeMarginInlineEnd = getNegativeMargins('marginInlineEnd');
  var style = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getResponsiveProps('bleed', 'margin-block-start', 'space', negativeMarginBlockStart)), getResponsiveProps('bleed', 'margin-block-end', 'space', negativeMarginBlockEnd)), getResponsiveProps('bleed', 'margin-inline-start', 'space', negativeMarginInlineStart)), getResponsiveProps('bleed', 'margin-inline-end', 'space', negativeMarginInlineEnd));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Bleed,
    style: sanitizeCustomProperties(style)
  }, children);
};
export { Bleed };